import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.css'],
    standalone: false
})
export class InputComponent implements OnInit {

  @Input() id: string;
  @Input() name: string;
  @Input() value: string;
  @Input() type: string;
  @Input() index: string;
  @Input() required: boolean;

  constructor() { }

  ngOnInit() {
  }

}
